export default __webpack_public_path__ + "static/media/webinar1.8ad71e08.svg";